import { Feature, type FeatureType } from "src/states/ApplicationState";

export type ServitutRedegoerelsePhase = "A" | "B";

export function canUseServitutRedegoerelse(
   hasAccessToFeature: (feature: FeatureType) => boolean,
): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelse)
      || hasAccessToFeature(Feature.ServitutRedegoerelseA)
      || hasAccessToFeature(Feature.ServitutRedegoerelseAView)
      || hasAccessToFeature(Feature.ServitutRedegoerelseB)
      || hasAccessToFeature(Feature.ServitutRedegoerelseBView);
}

export function canUsePhaseA(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelse)
      || hasAccessToFeature(Feature.ServitutRedegoerelseA)
      || hasAccessToFeature(Feature.ServitutRedegoerelseAView);
}

export function canUsePhaseB(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelse)
      || hasAccessToFeature(Feature.ServitutRedegoerelseB)
      || hasAccessToFeature(Feature.ServitutRedegoerelseBView);
}

export function canWritePhaseA(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelse)
      || hasAccessToFeature(Feature.ServitutRedegoerelseA);
}

export function canWritePhaseB(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelse)
      || hasAccessToFeature(Feature.ServitutRedegoerelseB);
}
